import React from 'react';
import { Button, CardContent, Grid, Typography } from '@material-ui/core';
import Card from '@material-ui/core/Card';
import { useStyles } from './FabricaInsumosInstrucoesStyles';
import clsx from 'clsx';
import Divider from '@material-ui/core/Divider';

export const FabricaInsumosInstrucoes = props => {
  const { setMostrarInstrucoes } = props;
  const classes = useStyles();

  return (
    <Grid
      container
      spacing={2}
    >
      <Grid
        item
        md={12}
        xs={12}
      >
        <Card
          variant={'elevation'}
          elevation={8}
          className={clsx({
            [classes.root]: true
          })}
        >
          <CardContent>
            <Grid
              container
              spacing={2}
            >
              <Grid
                item
                md={12}
                xs={12}
              >
                <Typography
                  variant="h3"
                  color="textPrimary"
                  gutterBottom
                  className={clsx({
                    [classes.title]: true
                  })}
                >
                  Fabricação de insumos
                </Typography>
              </Grid>
              <Grid
                item
                md={12}
                xs={12}
              >
                <Typography
                  variant="h6"
                  color="textSecondary"
                  gutterBottom
                  className={clsx({
                    [classes.instrucoes]: true
                  })}
                >
                  A fabricação de insumos é o processo de gerar um insumo a partir de outros. Dessa forma, o estoque de
                  um insumo X será incrementado e o estoque de outro insumo Y será decrementado.
                  Para realizar esse processo, você precisará escolher os insumos que participaram da fabricação, ou seja,
                  que terão seus estoques decrementados, e informar a quantidade que será usada na fabricação.
                  Da mesma forma, você escolherá os insumos que serão gerados, ou seja, que terão seus estoques incrementados, e
                  informará a quantidade que será gerada. Esse processo requer cuidado pois influenciará diretamente
                  nos estoques dos insumos do sistema, portanto, escolha com calma e informe as quantidades corretamente.
                  Uma vez que o processo esteja finalizado, ele não poderá ser desfeito!
                </Typography>
              </Grid>
              <Grid
                item
                md={12}
                xs={12}
              >
                <Divider/>
              </Grid>
              <Grid
                item
                md={12}
                xs={12}
                className={clsx({
                  [classes.gridBotaoContinuar]: true
                })}
              >
                <Button
                  variant={'contained'}
                  className={clsx({
                    [classes.botaoContinuar]: true
                  })}
                  onClick={e => setMostrarInstrucoes(false)}
                >
                  DESEJO CONTINUAR
                </Button>
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      </Grid>
    </Grid>
  );
};
